import { render } from "./SignupPassword.vue?vue&type=template&id=d04699a0&scoped=true"
import script from "./SignupPassword.vue?vue&type=script&lang=js"
export * from "./SignupPassword.vue?vue&type=script&lang=js"

import "./SignupPassword.vue?vue&type=style&index=0&id=d04699a0&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04699a0"]])

export default __exports__